import { Modal, Backdrop, Box, Grid } from "@mui/material";
import React from "react";
import Fade from "@mui/material/Fade";
import Typography from "@mui/material/Typography";

// TODO: Fix top: 46%, was playing around to make it work on desktop, laptop and phone...
const style = {
  position: "absolute",
  top: "47%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  bgcolor: "background.paper",
  borderRadius: 2,
  boxShadow: 24,
  p: 3,
  maxWidth: "90vw",
};

function PlanPrompt(props) {
  return (
    <Modal
      aria-labelledby="transition-modal-title"
      aria-describedby="transition-modal-description"
      open={props.open}
      onClose={props.handleClose}
      closeAfterTransition
      BackdropComponent={Backdrop}
      BackdropProps={{
        timeout: 500,
      }}
    >
      <Fade in={props.open}>
        <Box sx={style}>
          <Grid container justifyContent={"center"}>
            <Grid item sm={12}>
              <Typography variant="h5" align="center" sx={{ mb: 2 }}>
                Sorry
              </Typography>
            </Grid>
            <Grid item sm={12} textAlign={"center"}>
              <Typography variant="body">
                We cannot connect a flat rate plan to a property with a smart
                meter. Choose Lightning or Millennium instead!
              </Typography>
            </Grid>
          </Grid>
        </Box>
      </Fade>
    </Modal>
  );
}

export default PlanPrompt;
